import { IReward } from "@gig/magic-sdk/dist/adapter/rewards/reward";

export interface ILoyaltyState {
   level: number | null;
   points: number | null;
   pointsNextLevel: number | null;
   pointsPreviousLevel: number | null;
   progress: number | null;
   loyaltyLoaded: boolean,
   tier: number | null,
   isLoading: boolean;
   rewards: Record<string, IReward>;
   userRewardsEchoes: number;
   userRewards: Record<string, string[]> | null;
   rewardsCount: number;
}

export const LOYALTY_NAMESPACE = 'loyalty';
export const SET_REWARDS = 'SET_REWARDS';
export const SET_USER_REWARDS = 'SET_USER_REWARDS';
export const SET_REWARD_COUNT = 'SET_REWARD_COUNT';
export const SET_REWARD_COUNT_LOADING = 'SET_REWARD_COUNT_LOADING';
export const CLEAR_REWARD_COUNT = 'CLEAR_REWARD_COUNT';
export const SET_USER_PROGRESS = 'SET_USER_PROGRESS';
export const SET_LOYALTY_LOADED = 'SET_LOYALTY_LOADED';
export const SET_LOYALTY_TIER = 'SET_LOYALTY_TIER';

